import format from './date';

/**
 * @param value 能转换成Date对象的数字, 字符串或者Date对象
 * @param formatStr 要使用的格式化字符串形式
 * @example $datetime(new Date(2014, 1, 11)) => '2014-02-11 00:00:00'
 */
export default function (value: string | number | Date, formatStr: string = 'YYYY-MM-DD HH:mm:ss'): string{
	return format(value, formatStr);
}
